import { render, staticRenderFns } from "./AreaOperatore.vue?vue&type=template&id=d18ed078"
import script from "./AreaOperatore.vue?vue&type=script&lang=js"
export * from "./AreaOperatore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports